<template>
  <page-view class="page-invoice-detail mwclg-style">
    <div slot="pageRight">
      <!-- <div class="order-search">
        <p class="title">发票详情: {{ pageDetail.invoiceNo }}</p>
      </div> -->
      <div class="order-search">
        <div class="page-nav">
          <el-button
            class="btn-nav-back"
            plain
            size="mini"
            icon="el-icon-back"
            @click="$router.go(-1)"
            >{{ $t('InvoiceInquiry.return') }}</el-button
          >
          <p class="title nav-title">
            {{ $t('InvoiceInquiry.InvoiceNumber') }}:
            {{ invoiceForm.taxInvoiceNo }}
          </p>
        </div>
        <div class="flex">
          <el-form
            ref="detailDesc"
            :model="invoiceForm"
            style="flex: 1"
            label-width="90px"
          >
            <el-row :gutter="4">
              <el-col :span="COL_SPAN">
                <el-form-item
                  :label="$t('InvoiceInquiry.InvoiceIssuingEntity')"
                >
                  <el-input
                    v-model="invoiceForm.officeName"
                    size="small"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="COL_SPAN">
                <el-form-item :label="$t('InvoiceInquiry.InvoiceTitle')">
                  <el-input
                    v-model="invoiceForm.invHeadName"
                    size="small"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="COL_SPAN">
                <el-form-item :label="$t('InvoiceInquiry.TypeOfBill')">
                  <el-input
                    :value="invoiceForm.invType | codeToName('INVOICE_BASE')"
                    size="small"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="COL_SPAN">
                <el-form-item :label="$t('InvoiceInquiry.BillNumber')">
                  <el-input
                    v-model="invoiceNo"
                    size="small"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="4">
              <el-col :span="COL_SPAN">
                <el-form-item :label="$t('InvoiceInquiry.InvoiceDate')">
                  <el-input
                    v-model="invoiceForm.taxInvoiceDate"
                    size="small"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="COL_SPAN">
                <el-form-item :label="$t('InvoiceInquiry.InvoiceType')">
                  <el-input
                    :value="invoiceForm.taxInvType | codeToName('INVOICE_TYPE')"
                    size="small"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="COL_SPAN">
                <el-form-item :label="$t('InvoiceInquiry.InvoiceValue')">
                  <el-input :value="invoiceForm.amount" size="small" readonly>
                    <template slot="append">{{
                      invoiceForm.currType || ''
                    }}</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="COL_SPAN">
                <el-form-item :label="$t('InvoiceInquiry.ReceivableBalance')">
                  <el-input
                    :value="invoiceForm.balanceAmount"
                    size="small"
                    readonly
                  >
                    <template slot="append">{{
                      invoiceForm.currType || ''
                    }}</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="4">
              <el-col :span="COL_SPAN">
                <el-form-item :label="$t('InvoiceInquiry.BillingPeriod')">
                  <el-input
                    :value="invoiceForm.paymentDays"
                    size="small"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="COL_SPAN * 3">
                <el-form-item :label="$t('HistoricalRedemptionRecords.Note')">
                  <el-input
                    :value="invoiceForm.remark"
                    size="small"
                    readonly
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="order-list">
        <p class="title">
          {{ $t('InvoiceInquiry.InvoiceDetails')
          }}<el-button
            type="primary"
            size="small"
            :loading="exportLoading"
            style="margin-left: 10px"
            @click="exportInvoiceDetail()"
            >{{ $t('InvoiceInquiry.ExportDetails') }}</el-button
          >
        </p>
        <el-table
          v-loading="pageLoading"
          :data="tableData"
          stripe
          style="width: 100%"
        >
          <!-- <el-table-column prop="invHeadName" label="发票抬头" width="240" show-overflow-tooltip></el-table-column> -->
          <!-- <el-table-column prop="customerBillNo" label="客户编号" width="140" show-overflow-tooltip></el-table-column> -->
          <!-- <el-table-column prop="mblNo" label="主关单号" show-overflow-tooltip></el-table-column> -->
          <!-- <el-table-column prop="taxInvoiceNo" label="发票号(金)" width="100" show-overflow-tooltip></el-table-column> -->
          <el-table-column
            prop="jobNo"
            :label="$t('InvoiceInquiry.BusinessNumber')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="chargeName"
            :label="$t('InvoiceInquiry.FeeName')"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="chargeAnotherName"
            :label="$t('InvoiceInquiry.ExpenseAlias')"
            show-overflow-tooltip
          ></el-table-column>
          <!-- <el-table-column prop="taxInvoiceDate" label="开票日期" width="100"></el-table-column> -->
          <el-table-column
            prop="currType"
            :label="$t('InvoiceInquiry.CurrencyType')"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="unitPrice"
            :label="$t('InvoiceInquiry.price')"
            width="140"
            align="right"
          >
            <template #default="{ row }">
              <span>{{ new Big(row.unitPrice).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="unitCount"
            :label="$t('HistoricalRedemptionRecords.Quantity')"
            width="140"
            align="right"
          >
          </el-table-column>
          <el-table-column
            prop="amount"
            :label="$t('InvoiceInquiry.AmountOfMoney')"
            width="140"
            align="right"
          >
            <template #default="{ row }">
              <span>{{ new Big(row.amount).toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taxRate"
            :label="$t('InvoiceInquiry.TaxRate')"
            width="100"
            align="right"
          >
          </el-table-column>
          <!-- <el-table-column prop="actualPayableDate" label="实际付款日"></el-table-column> -->
        </el-table>
        <!-- <div v-else style="text-align:center;padding:20px">暂无数据</div> -->
        <!-- <el-pagination
          v-show="tableData && tableData.length"
          style="text-align:right"
          background
          layout="prev, pager, next"
          :page-size="pageInfo.pageSize"
          :total="pageInfo.total"
          @current-change="currentPageChange"
        >
        </el-pagination> -->
      </div>
    </div>
  </page-view>
</template>
<script>
import { PageView } from '@/components'
import constants from '@/constants'
import { getInvoiceDetail, exportInvoiceDetailList } from '@/api/invoice'
import { HttpResponseCode } from '@/utils/request'
import Big from 'big.js'
// import TableList from './modules/tableList'
// import { GetARByCusID } from '@/api/order'
// import { USER_INFO } from '@/store/mutation-types'
export default {
  name: 'InvoiceDetail',
  components: { PageView },
  data() {
    this.Big = Big
    return {
      COL_SPAN: 6,
      INVOICE_BASE: constants.INVOICE_BASE,
      INVOICE_TYPE: constants.INVOICE_TYPE,
      invoiceNo: '',
      paymentDate: [],
      pageLoading: false,
      tableData: [],
      pageInfo: {
        pageSize: 10,
        page: 1,
        total: 11
      },
      invoiceForm: {
      },
      queryParams: {},
      orderTotal: {
        totalQty: 0,
        totalBaseQty: 0,
        totalNetWeight: 0,
        totalGrossWeight: 0
      },
      jobType: '',
      userData: '',
      loading: false,
      exportLoading: false
    }
  },
  created() {
    this.invoiceNo = this.$route.query.invoiceNo || ''
    this.search()
  },
  methods: {
    async search() {
      this.pageLoading = true
      await getInvoiceDetail({ invoiceNo: this.invoiceNo }).then(res => {
        if (res && res.code === HttpResponseCode.SUCCESS && res.data) {
          this.tableData = res.data.invoiceDetailList.map(item => {
            return {
              ...item,
              taxRate: res.data.taxRate ?? '--'
            }
          })
          this.invoiceForm = {
            ...res.data,
            invoiceDetailList: undefined
          }
        }
      })
      this.pageLoading = false
    },
    goSearch() { },
    reset() { },
    searchTimeChange() { },
    currentPageChange() { },
    async exportInvoiceDetail() {
      console.log('导出发票详情')
      this.exportLoading = true
      await exportInvoiceDetailList({ invoiceNo: this.invoiceNo }).then(res => {
        this.exportLoading = false
      })
    }
    // search () {
    //   const userInfo = this.$ls.get(USER_INFO)
    //   this.queryParams.CustomerId = userInfo.CACode
    //   this.loading = true
    //   GetARByCusID(this.queryParams).then(res => {
    //     this.dataList = res.Data.CbList || []
    //     this.loading = false
    //   }).catch(() => {
    //     this.loading = false
    //   })
    // },
    // reset () {
    //   this.queryParams = {}
    //   this.search()
    // }
  }
}
</script>
<style lang="less">
.page-invoice-detail {
  padding: 10px;
  background: #f0f6fb;
  // .plr25 {
  //   padding-left: 0px !important;
  //   padding-right: 0px !important;
  // }
  // .ptb25 {
  //   padding-top: 0px !important;
  //   padding-bottom: 0px !important;
  // }
  .order-search {
    background: white;
    border-radius: 4px;
    padding: 16px 20px;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 6px;
    border: 0px;
    background: #f6f6f8;
  }
  .el-form-item__content .el-input-group {
    vertical-align: middle;
  }
  .page-nav {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .btn-nav-back {
      padding: 6px 8px;
      margin-right: 12px;
      &.el-button--default {
        color: #606266 !important;
        border-color: #dcdfe6 !important;
      }
    }
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 22px;
    margin-bottom: 20px;
  }
  .nav-title {
    margin-bottom: 0;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 16px 20px;
    min-height: 60vh;
    .list-item {
      margin-bottom: 8px;
    }
  }
  // .header_icon {
  //   width: 34px;
  //   height: 34px;
  //   display: inline-block;
  // }
  // .order-no {
  //   font-size: 16px;
  //   font-weight: 400;
  //   color: #111827;
  //   margin-left: 18px;
  //   display: inline-block;
  // }
  // .order-head-infomation {
  //   padding-left: 52px;
  //   display: flex;
  //   justify-content: flex;
  // }
  // .detail-info {
  //   border-radius: 10px;
  //   // border: 1px solid #e9ecf2;
  //   padding: 16px 0;
  //   display: flex;
  //   justify-content: flex-start;
  //   background: #F6F6F8;
  //   .detail-info-status {
  //     background: #59b9d3;
  //     width: 3px;
  //     margin-left: -1px;
  //     border-radius: 0 16px 16px 0;
  //   }
  //   .detail-info-content {
  //     flex: 1;
  //     margin-left: 20px;
  //   }
  //   .track-btn {
  //     width: 107px;
  //     height: 28px;
  //     background: #59b9d3;
  //     border-radius: 4px;
  //     margin: 45px 23px;
  //     line-height: 8px;
  //   }
  // }
}
</style>
